import { render } from "./ModalRemitos.vue?vue&type=template&id=168430df"
import script from "./ModalRemitos.vue?vue&type=script&lang=js"
export * from "./ModalRemitos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__